// Smart Sash Admin Panel - Institution Management Page

import { Alert, Button, PermissionGate } from '@/components/common';
import {
  InstitutionDeleteModal,
  InstitutionFormModal,
  InstitutionTable,
} from '@/components/institution';
import { useInstitutionManagement } from '@/hooks/useInstitutionManagement';
import React from 'react';

export const InstitutionManagement: React.FC = () => {
  const {
    institutions,
    pagination,
    isLoading,
    error,
    currentPage,
    pageSize,
    pageSizeOptions,
    showModal,
    modalMode,
    showDeleteModal,
    institutionToDelete,
    formData,
    isSaving,
    setCurrentPage,
    handlePageSizeChange,
    handleCreateClick,
    handleEditClick,
    handleDeleteClick,
    handleSubmit,
    handleDelete,
    handleFieldChange,
    handleInputChange,
    closeModal,
    closeDeleteModal,
    clearError,
  } = useInstitutionManagement();

  return (
    <div className="container-fluid py-4">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="h3 mb-0">Institution Management</h1>
              <p className="text-muted">Manage institutions and organizational units</p>
            </div>
            <PermissionGate action="institution:create">
              <Button variant="primary" icon="fas fa-plus" onClick={handleCreateClick}>
                Add Institution
              </Button>
            </PermissionGate>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="row mb-3">
          <div className="col-12">
            <Alert variant="danger" dismissible onDismiss={clearError}>
              <i className="fas fa-exclamation-circle me-2"></i>
              {error}
            </Alert>
          </div>
        </div>
      )}

      {/* Institutions Table */}
      <div className="row">
        <div className="col-12">
          <InstitutionTable
            institutions={institutions}
            pagination={pagination}
            currentPage={currentPage}
            pageSize={pageSize}
            pageSizeOptions={pageSizeOptions}
            isLoading={isLoading}
            onPageChange={setCurrentPage}
            onPageSizeChange={handlePageSizeChange}
            onEdit={handleEditClick}
            onDelete={handleDeleteClick}
          />
        </div>
      </div>

      {/* Create/Edit Modal */}
      <InstitutionFormModal
        isOpen={showModal}
        mode={modalMode}
        formData={formData}
        isSaving={isSaving}
        onFieldChange={handleFieldChange}
        onInputChange={handleInputChange}
        onSubmit={handleSubmit}
        onClose={closeModal}
      />

      {/* Delete Confirmation Modal */}
      <InstitutionDeleteModal
        isOpen={showDeleteModal}
        institution={institutionToDelete}
        isSaving={isSaving}
        onConfirm={handleDelete}
        onClose={closeDeleteModal}
      />
    </div>
  );
};

export default InstitutionManagement;
